import { render } from "./ServiceExtras.vue?vue&type=template&id=71578eb2&scoped=true"
import script from "./ServiceExtras.vue?vue&type=script&lang=js"
export * from "./ServiceExtras.vue?vue&type=script&lang=js"

import "./ServiceExtras.vue?vue&type=style&index=0&id=71578eb2&scoped=true&lang=css"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71578eb2"]])

export default __exports__